import { Component } from '@angular/core';

@Component({
  selector: 'app-construction',
  styleUrls: ['construction.scss'],
  templateUrl: 'construction.html'
})
export class ConstructionComponent {

  

}
